import React from 'react';
import WidgetPlayer from '../components/WidgetPlayer';
import CutePlayer from '../components/CutePlayer';

const EmbedView = ({ streamUrl, logoUrl, type = "widget" }) => {
  // We use a dedicated container that takes exactly the viewport size
  // and removes any potential overflow issues
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-transparent overflow-hidden">
      <div className="w-full h-full flex items-center justify-center p-2">
        {type === "cute" ? (
          <div className="w-full max-w-4xl">
            <CutePlayer streamUrl={streamUrl} logoUrl={logoUrl} isEmbedded={true} />
          </div>
        ) : (
          <WidgetPlayer streamUrl={streamUrl} logoUrl={logoUrl} isEmbedded={true} />
        )}
      </div>
    </div>
  );
};

export default EmbedView;